module.exports = __webpack_public_path__ + "assets/img/btn-view-info-hover-2a82b0c1.png";